import service, {
  IMaterial,
  IMaterialId,
} from '@/services/material';
import { IPage } from '@/services/gql/generic-find';
import { debounceSearch, promiseError } from '@/store/utils';
import { IStateMaterials } from './types';

export default () => ({
  namespaced: true,
  state: () => ({
    list: [],
    loadSeeds: [],
    page: {
      number: 1,
      query: {},
      recordCount: 0,
      size: 10,
    },
  } as IStateMaterials),
  getters: {
    isSearchLoading: (state: IStateMaterials) => !!state.loadSeeds.length,
  },
  mutations: {
    LOAD(state: IStateMaterials, data: IMaterial[] = []) {
      state.list = data;
    },
    LOAD_SEED_ADD(state: IStateMaterials, seed: number) {
      state.loadSeeds = state.loadSeeds.concat(seed);
    },
    LOAD_SEED_CLEAR(state: IStateMaterials) {
      state.loadSeeds = [];
    },
    LOAD_SEED_REMOVE(state: IStateMaterials, seed: number) {
      state.loadSeeds = state.loadSeeds.filter(loadSeed => loadSeed !== seed);
    },
    REMOVE(state: IStateMaterials, id: IMaterialId) {
      // reduce record count by 1
      state.page.recordCount = state.page.recordCount - 1;

      // remove item from list
      state.list = state.list.filter((item: IMaterial) => (
        item.id !== id
      ));
    },
    UPDATE_PAGE(state: IStateMaterials, payload: any) {
      state.page = {
        ...state.page,
        ...payload,
      };
    },
  },
  actions: {
    load: ({ commit, state }: any, page: IPage) => (
      debounceSearch({
        commit,
        page,
        service,
        state,
        onSearch: (pageParams: any) => (
          service.find(`id, name`, {
            ...pageParams,
            where: state.page.query,
          })
        ),
      })
    ),
    remove: ({ commit }: any, id: string) => (
      service
        .remove(id)
        .then(() => commit('REMOVE', id))
        .catch(promiseError('MATERIALS_REMOVE', commit))
    ),
  },
});
